import styled from 'styled-components'
import { Modal } from 'antd'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'

export const ModalStyled = styled(Modal)`
    top: 24px;

    & .ant-tabs-tab {
        padding-left: 0px !important;
    }
`

export const CalculationsTableWrapper = styled(TableWrapper)`
    .ant-table-tbody > tr.calculation-table-row--position .ant-table-cell {
        background-color: var(--calculation-row-color, #ffffff);
        transition: background-color 0.2s ease;
    }

    .ant-table-tbody > tr.calculation-table-row--position:hover .ant-table-cell {
        background-color: #f5f5f5 !important;
    }

    /* Ячейка с валидацией: сохраняем подсветку при hover (иначе бьёт правило выше с !important) */
    .ant-table-tbody
        > tr.calculation-table-row--position:hover
        .ant-table-cell[data-cell-validated] {
        background-color: var(--cell-validation-bg) !important;
    }

    /*
     * Для строк типа calculation колонка copies растягивается на много колонок (colSpan),
     * поэтому фиксированное позиционирование может перекрыть уже фиксированную comment слева.
     * Деактивируем sticky именно для этой ячейки.
     */
    .ant-table-tbody
        > tr.calculation-table-row--calculation
        .ant-table-cell.copies-cell--not-fixed {
        position: static !important;
        left: auto !important;
        z-index: 1 !important;
        background: white;
    }
`
